import { SHOW_LOADER } from '../actions'

export function showLoader(payload) {
	return { type: SHOW_LOADER, payload }
}
